import { gql } from "@apollo/client";

export default gql`
  mutation deleteDeliveryIn($_id: String) {
    deleteDeliveryIn(_id: $_id) {
      ok
      message
      error
    }
  }
`;
